module.exports = __webpack_public_path__ + "img/icon_2_31.d2cf6040.png";